// @ts-nocheck
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import React from "react";

interface BuyingListDetailsLinkProps {
    id: string;
    name: string;
}

const BuyingListDetailsLink: React.FC<BuyingListDetailsLinkProps> = ({ id, name }) => {
    return (
        <>
            {createWidgetElement("Basic/PageTypeLink", {
                fields: {
                    overrideTitle: name,
                    pageType: "BuyingListDetailsPage",
                    queryString: `id=${id}`,
                },
            })}
        </>
    );
};
export default BuyingListDetailsLink;
